import { CHANGE_LEADOM_CONFIG_REQUEST, CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS, CHANGE_LEADOM_CONFIG_REQUEST_FAILURE } from '../constants/leadom_config.constants';

export const changeLeadOMRequest = (_id, config) => ({
    type: CHANGE_LEADOM_CONFIG_REQUEST,
    _id,
    config,
});

export const changeLeadOMConfigRequestSuccess = payload => ({
    type: CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS,
    payload,
});

export const changeLeadOMConfigRequestFailure = error => ({
    type: CHANGE_LEADOM_CONFIG_REQUEST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/actions/change_leadom_config.actions.js